import React from 'react';
import Rating from '../../../utils/Rating';
import ScoreCountDaily from '../../common/ScoreCountDaily';

const RatingRow = ({dayData, spot}) => {

    if(!spot){
        return <></>
    }

    if(!dayData.time){
        return <></>
    }

    const {preferred_wave_height_min, preferred_wave_height_max, preferred_swell_period_min, preferred_swell_period_max, preferred_wind_speed_min, preferred_wind_speed_max, preferred_wind_direction, preferred_swell_direction} = spot;

    

    if(!preferred_wave_height_min && !preferred_wave_height_max && !preferred_swell_period_min && !preferred_swell_period_max && !preferred_wind_speed_min && !preferred_wind_speed_max && !preferred_wind_direction && !preferred_swell_direction){
        return <></>
    }

    return (
        <tr className="hover:bg-custom-darker/50 transition-colors">
            <td className="pl-2 pb-1 pt-2 text-xs text-custom-light-grey ">
                <div className="inline-flex items-center gap-2 font-medium">
                    <div>
                        Rating
                    </div>
                </div>
            </td>
            {dayData.time.map((value, index) => {

                const rating = new Rating({
                    waveheight: dayData.wave_height_max?.[index],
                    swellperiod: dayData.wave_period_max?.[index],
                    swelldirection: dayData.wave_direction_dominant?.[index],
                    windspeed: dayData.wind_speed_10m_max?.[index],
                    winddirection: dayData.wind_direction_10m_dominant?.[index]
                }, {
                    preferred_wave_height_min,
                    preferred_wave_height_max,
                    preferred_swell_period_min,
                    preferred_swell_period_max,
                    preferred_wind_speed_min,
                    preferred_wind_speed_max,
                    preferred_wind_direction,
                    preferred_swell_direction
                })

                return (
                    <td key={index} className="pl-2 pb-1 pt-2 text-center">
                        <div className="inline-flex flex-col items-center gap-1">
                            <ScoreCountDaily score={rating.score} />
                        </div>
                    </td>
                );
            })}
        </tr>
    )
}

export default RatingRow;